import formatDateOnly from '~support-at-home/lib/formatDateOnly';

import { Column } from '~components/table-view';
import { genericCellRender } from '~components/table-view/columnRenderers';
import { renderRegisteredServiceStatusBadge } from '~support-at-home/components/proda/SahRegisteredServicesCells';

// TAV-3332. Sized against `minimalView`'s trimmed padding so all 6 columns fit the lg Settings
// modal's roughly 740px of content without a horizontal scrollbar. Service Group and Service Type
// are the two fluid columns, each floored at SERVICE_NAME_MIN_PX; long service type names wrap
// rather than truncate.
const SERVICE_NAME_MIN_PX = 130;
const TYPE_CODE_PX = 95;
// Measured in the browser at the modal's font: a DD/MMM/YYYY date needs 112px and the "Not yet
// effective" badge 138px (cell padding included) to stay on one line under minimal's break-word.
const DATE_PX = 115;
const STATUS_PX = 145;

// The width below which the registered-services table should scroll rather than keep compressing.
// See the `minTableWidth` comment in `forms/budgets/sectionItemsList.ts` for why the floor goes on
// the table rather than on the fluid columns themselves.
export const registeredServicesMinTableWidth = SERVICE_NAME_MIN_PX * 2 + TYPE_CODE_PX + DATE_PX * 2 + STATUS_PX;

// Column[] for the "Registered Services" tab — pure display, no closures over live component
// state, so a plain array rather than a factory.
export const registeredServicesColumns: Column[] = [
  {
    id: 'service_group_text',
    header: 'Service Group',
    type: 'text',
  },
  {
    id: 'service_type_text',
    header: 'Service Type',
    type: 'text',
  },
  {
    id: 'service_type_id',
    header: 'Type Code',
    type: 'text',
    style: { width: `${TYPE_CODE_PX}px` },
  },
  {
    id: 'start_date',
    header: 'Start',
    type: 'text',
    style: { width: `${DATE_PX}px` },
    deriveValue: (row) => formatDateOnly(row.start_date),
  },
  {
    id: 'end_date',
    header: 'End',
    type: 'text',
    style: { width: `${DATE_PX}px` },
    deriveValue: (row) => formatDateOnly(row.end_date),
  },
  {
    id: 'status',
    header: 'Status',
    type: 'text',
    style: { width: `${STATUS_PX}px` },
    renderReadOnly: genericCellRender(renderRegisteredServiceStatusBadge),
  },
];
